module.exports = __webpack_public_path__ + "static/media/otherSwirl.a87c7cbe.svg";